
import { call, put, takeEvery, takeLatest } from "redux-saga/effects";
import { eThangDiemActionTypeIds, IThangDiemActions } from "../../action-types/IThangDiemActionType";
import { actions } from "../../actions/actionsWrapper";
import { thangDiemApi } from "../../../api/thangDiemApi";
import { IBaseResponeModel } from "../../../models/response/base-response";
import { IThangDiem } from "../../../models/response/so-diem/IThangDiem";
const mainAction = actions.soDiem.thangDiem;
export function* thangDiemSaga(): any {
    yield takeLatest(eThangDiemActionTypeIds.LOAD_START, loadWorker)
    yield takeEvery(eThangDiemActionTypeIds.SAVE_START, saveWorker)
    yield takeEvery(eThangDiemActionTypeIds.DELETE_START, deleteWorker)
}

function* loadWorker(action: IThangDiemActions): any {
    const res: IBaseResponeModel = yield call(thangDiemApi.SelectByTruong, action.payload as number)
    if (res.is_success) {
        yield put(mainAction.LOAD_SUCCESS(res.data))
    } else {
        yield put(mainAction.LOAD_ERROR(res.message ?? "Có lỗi"))
    }
}

function* saveWorker(action: IThangDiemActions): any {
    let res: IBaseResponeModel;
    const payload = action.payload as IThangDiem;
    if (payload.id > 0) {
        res = yield call(thangDiemApi.Update, payload)
    } else {
        res = yield call(thangDiemApi.Insert, payload)
    }
    if (res.is_success) {
        yield put(mainAction.SAVE_SUCCESS(res.data))
    } else {
        yield put(mainAction.SAVE_ERROR(res.message ?? "Có lỗi"))
    }
}

function* deleteWorker(action: IThangDiemActions): any {
    const res: IBaseResponeModel = yield call(thangDiemApi.Delete, action.payload as number)
    if (res.is_success) {
        yield put(mainAction.DELETE_SUCCESS(res.data))
    } else {
        yield put(mainAction.DELETE_ERROR(res.message ?? "Có lỗi"))
    }
}
